/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RentType = 'PERCENT' | 'HA' | 'BPEJ' | 'DEAL' | 'KATUZE';

export const RentType = {
    PERCENT: 'PERCENT' as RentType,
    HA: 'HA' as RentType,
    BPEJ: 'BPEJ' as RentType,
    DEAL: 'DEAL' as RentType,
    KATUZE: 'KATUZE' as RentType
};

